const configuredDeploymentId = import.meta.env.VITE_CHAMS_DEPLOYMENT_ID?.trim();

export const deploymentId =
  configuredDeploymentId && /^[a-z0-9][a-z0-9-]{2,62}$/.test(configuredDeploymentId)
    ? configuredDeploymentId
    : "chams-pay-local-synthetic";

export const deploymentIdentity = {
  schoolNameAr: import.meta.env.VITE_CHAMS_SCHOOL_NAME_AR,
  schoolNameFr: import.meta.env.VITE_CHAMS_SCHOOL_NAME_FR,
  addressAr: import.meta.env.VITE_CHAMS_SCHOOL_ADDRESS_AR,
  addressFr: import.meta.env.VITE_CHAMS_SCHOOL_ADDRESS_FR,
  email: import.meta.env.VITE_CHAMS_SCHOOL_EMAIL,
  phone: import.meta.env.VITE_CHAMS_SCHOOL_PHONE,
} as const;

export const deploymentProductName = import.meta.env.VITE_CHAMS_PRODUCT_NAME || "Chams.Pay";
export const deploymentLevelLabels = (
  import.meta.env.VITE_CHAMS_LEVEL_LABELS || "PS|MS|GS|CP|CE1|CE2|CM1|CM2|6ème"
)
  .split("|")
  .filter(Boolean);

function rgb(hex: string): readonly [number, number, number] {
  const match = /^#([0-9a-f]{6})$/i.exec(hex);
  if (!match) return [42, 138, 148];
  const value = Number.parseInt(match[1]!, 16);
  return [(value >> 16) & 255, (value >> 8) & 255, value & 255];
}

function mix(
  color: readonly [number, number, number],
  target: readonly [number, number, number],
  ratio: number,
): readonly [number, number, number] {
  return color.map((value, index) =>
    Math.round(value * (1 - ratio) + target[index]! * ratio),
  ) as unknown as readonly [number, number, number];
}

function triplet(color: readonly [number, number, number]): string {
  return color.join(" ");
}

function hex(color: readonly [number, number, number]): string {
  return `#${color.map((value) => value.toString(16).padStart(2, "0")).join("")}`;
}

export function applyDeploymentBranding(root: HTMLElement = document.documentElement): void {
  const primary = rgb(import.meta.env.VITE_CHAMS_BRAND_COLOR || "#2A8A94");
  const hover = mix(primary, [0, 0, 0], 0.16);
  const strong = mix(primary, [0, 0, 0], 0.32);
  const soft = mix(primary, [255, 255, 255], 0.91);
  const accent = mix(primary, [255, 255, 255], 0.8);
  const secondary = mix(primary, [255, 255, 255], 0.2);
  const properties = {
    "--primary": triplet(primary),
    "--primary-hover": triplet(hover),
    "--primary-strong": triplet(strong),
    "--primary-soft": triplet(soft),
    "--secondary": triplet(secondary),
    "--accent": triplet(accent),
    "--accent-foreground": triplet(strong),
    "--ring": triplet(primary),
    "--sidebar-primary": triplet(primary),
    "--sidebar-accent-foreground": triplet(strong),
    "--sidebar-ring": triplet(primary),
    "--k-color-primary": triplet(primary),
    "--k-color-md-light-primary": triplet(primary),
    "--k-color-md-light-secondary": triplet(secondary),
    "--teal-50": hex(soft),
    "--teal-100": hex(mix(primary, [255, 255, 255], 0.8)),
    "--teal-400": hex(secondary),
    "--teal-500": hex(primary),
    "--teal-600": hex(hover),
    "--teal-700": hex(strong),
    "--chams-primary": hex(primary),
    "--deployment-primary-soft-desktop": triplet(mix(primary, [255, 255, 255], 0.86)),
    "--deployment-accent-desktop": triplet(mix(primary, [255, 255, 255], 0.72)),
  } as const;
  for (const [name, value] of Object.entries(properties)) root.style.setProperty(name, value);
}
